module.exports = __webpack_public_path__ + "static/media/image_down_arrow_selection.aeaa66a0.png";